import store from '@store';
import { APP_CONFIG } from '@constants';
import { getObjectValue } from '@utility/utills';
import {
  singleSend,
  replaceCart,
  removeItemFromCart,
  getUpdatedCart,
  deleteItm,
  updateSeatInfo,
  voidItm,
  setSeat,
  voidCheck,
  setUpdatingPosCartStatus,
  addChecks,
} from '@reducers/orders';
import { setErrorPopUp } from '@reducers/notification';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { addInProcessItemsToCart } from '../../MenuOrderHandler';
import { CUSTOM_MESSAGES } from '@veriables';
import CustomEventEmitter from '@utility/customEventEmitter';
import { safeJsonParse, filterNonHeldItems } from '@utility/helperFunction';
import getDeviceType from '@utility/deviceType';

export const sendAllItems = (type, navigate = () => {}, orderId, checkedItemIds = null, { onSuccess, onError } = {}) => {
  const { oauth, orders } = store.getState();
  let sendMode = false;
  if (type === 'sendAllPay') {
    sendMode = true;
    type = 'sendAll';
  }
  const cb = Cart => {
    const { orders: freshOrders } = store.getState();
    let cartToSend;
    if (checkedItemIds) {
      cartToSend = Cart.filter(item => checkedItemIds[item.internalId]);
    } else {
      const checkOrderItems = freshOrders.seats?.orders?.[0]?.items ?? [];
      cartToSend = filterNonHeldItems(Cart, checkOrderItems);
    }
    if (cartToSend.length === 0) return;
    store.dispatch(setUpdatingPosCartStatus(true));
    const dataToSend = {
      storeId: oauth.deviceInformation.storeId,
      employeeId: Number(oauth.loggedInUserData.id),
      deviceId: oauth.deviceInformation.deviceId,
      checkHeaderId: orders.seats.id,
      employeeCard: oauth.loggedInUserData.employeeCard,
      items: getLinkedMenuItemsId(cartToSend, type, orderId),
    };


    store
      .dispatch(singleSend(dataToSend))
      .then(res => {
        store.dispatch(setUpdatingPosCartStatus(false));
        cartToSend.forEach(item => store.dispatch(removeItemFromCart(item.internalId)));
        const updatedCart = getUpdatedCart();
        CustomEventEmitter.dispatchEvent('getCartItems', updatedCart);
        store.dispatch(updateChecksAfterResponse(res));
        onSuccess?.();
        if (
          res.sourceType === 0 &&
          oauth.authInfo.gamingSystemConfig &&
          activateGameCards(res)
        ) {
          navigate(`${APP_CONFIG.BASE_URL}/gamecard/${orders.seats.id}`, {
            replace: true,
          });
        } else if (isGiftCards(res)) {
          navigate(`${APP_CONFIG.BASE_URL}/giftcard/${orders.seats.id}`, {
            replace: true,
          });
        }
        if (sendMode) {
          navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${orders.seats.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
            { replace: true }
          );
        }
      })
      .catch(err => {
        store.dispatch(setUpdatingPosCartStatus(false));
        store.dispatch(
          setErrorPopUp({
            res: err.message,
          })
        );
        onError?.();
      });
  };
  // addInProcessItemsToCart(cb, orders.cart);
  const isAll = !checkedItemIds;
  if (
    oauth?.deviceInformation?.deviceGroup?.serverAppSettings
      ?.enforceBeverageRequirementBySeat === true && isAll
  ) {
    const invalidSeatNumbers = getInvalidateSeatsNumbers();
    if (invalidSeatNumbers.length && orders?.seats?.seats?.length >= 1) {
      store.dispatch(
        setErrorPopUp({
          res:
            CUSTOM_MESSAGES().BEVERAGE_REQUIREMENT_ERROR +
            invalidSeatNumbers.join(', '),
        })
      );
    } else {
      addInProcessItemsToCart(cb, orders.cart);
    }
  } else {
    addInProcessItemsToCart(cb, orders.cart);
  }
};

export const sendSelectedItems = (data = [], type = null, orderId = null) => {
  const { orders } = store.getState();
  const cb = Cart => {
    setSendLoader(true);
    const requiredCart = [];
    data.forEach(item => {
      if (item.hasLinkedMenuItem) {
        const linkedItems = Cart.filter(
          e =>
            e.isLinked &&
            e.uniqueIdForLinkedItem &&
            e.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem
        );
        requiredCart.push(...linkedItems);
      }
      const Item = Cart.find(i => i.internalId === item.internalId);
      requiredCart.push(Item);
    });
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      employeeId: Number(props.userInfo.id),
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: props.check.id,
      employeeCard: props.userInfo.employeeCard,
      items: getLinkedMenuItemsId(requiredCart, type, orderId),
    };
    props
      .singleSend(dataToSend)
      .then(res => {
        setSendLoader(false);
        requiredCart.forEach(i => {
          props.removeItemFromCart(i.internalId);
        });
        const updatedCart = getUpdatedCart();
        CustomEventEmitter.dispatchEvent('getCartItems', updatedCart);
        props.updateChecksAfterResponse(res);
        if (
          res.sourceType === 0 &&
          props.auth.gamingSystemConfig &&
          activateGameCards(res)
        ) {
          props.navigate(
            `${APP_CONFIG.BASE_URL}/gamecard/${props?.check?.id}`,
            { replace: true }
          );
        }
      })
      .catch(err => {
        setSendLoader(false);
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  addInProcessItemsToCart(cb, orders.cart);
};

const activateGameCards = data => {
  let value = false;
  let items = data?.orders[0].items;
  const { orders } = store.getState();
  items.forEach(i => {
    if (i.pending) {
      if (
        orders.menuItemsHashTable[JSON.parse(i.orderJson).menuItemId]
          .cardType == 1
      ) {
        value = true;
      }
    }
  });
  return value;
};

const isGiftCards = data => {
  let giftCards = data?.cards || [];
  return giftCards.some(el => el?.status === 0 && !el?.void);
};

const getLinkedMenuItemsId = (data, type, orderId) => {
  const menuList = [];
  const { orders } = store.getState();
  data.forEach(item => {
    let printOrderTypeId = null;
    const groupItem = orders.allMenusHashTable?.filter(
      Item => Item.id == item?.menuScreenId
    );
    if (
      groupItem[0]?.orderTypePrintRouting === true ||
      orders.menuItemsHashTable[item?.menuItemId]?.orderTypePrintRouting ===
      true
    ) {
      printOrderTypeId = orderId;
    }
    if (!item?.hasLinkedMenuItem) {
      menuList.push({
        checkOrderItemId: item?.id,
        orderSendMode: getOrderSendModeType(type),
        printRoutingOrderTypeId: printOrderTypeId,
      });
    } else {
      item?.modifiers?.forEach(e => {
        const linkedIndex = orders.cart.findIndex(
          d =>
            d.menuItemId === e.modifierId &&
            d.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem
        );
        if (linkedIndex > -1) {
          menuList.push({
            checkOrderItemId: orders.cart[linkedIndex].id,
            orderSendMode: getOrderSendModeType(type),
            printRoutingOrderTypeId: printOrderTypeId,
          });
        }
      });
      menuList.push({
        checkOrderItemId: item.id,
        orderSendMode: getOrderSendModeType(type),
        printRoutingOrderTypeId: printOrderTypeId,
      });
    }
  });
  return menuList;
};
const getOrderSendModeType = type => {
  switch (type) {
    case 'toGo':
      return 1;
    case 'doNotMake':
      return 2;
    case 'onTheFly':
    case 'runner':
      return 4;
    default:
      return 0;
  }
};

export const getTotalAmount = table => {
  const discount = getObjectValue(() => table.discountAmount, 0);
  const { oauth } = store.getState();
  const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
  return oauth.authInfo.country === 1 || oauth.authInfo.country === 2
    ? +(table.itemAmount + table.taxAmount + serviceCharge - discount)
    : +(table.itemAmount - discount);
};

const getSeatNumber = seatId => {
  const { orders } = store.getState();
  for (const seat of orders?.seats?.seats ?? []) {
    if (seat.id === seatId) {
      return seat.number;
    }
  }
};

const checkItemValidity = items => {
  const { orders } = store.getState();
  for (const item of items) {
    if (item?.brandCourseId) {
      if (orders.coursesHashTable[item.brandCourseId]?.beverageRequirement) {
        return true;
      }
    } else {
      const value = orders.menuItemsHashTable[item.menuItemId];
      if (
        value?.brandCourseId &&
        orders.coursesHashTable[value.brandCourseId]?.beverageRequirement
      ) {
        return true;
      }
    }
  }
  return false;
};

const availableInItem = (elem, itemsArray) => {
  const array = itemsArray.map(item => {
    if (item?.seats?.[0]?.seatId === elem.id) {
      return elem.id;
    }
  });
  return array.includes(elem.id);
};

const availableInCart = (elem, arr) => {
  const newArr = arr.filter(item => {
    return item?.seatIds?.[0] === elem.id;
  });
  return newArr.length !== 0;
};

const getInvalidateSeatsNumbers = () => {
  const { orders } = store.getState();
  const mapItemsWithSeatIds = new Map();
  const invalidSeatsId = [];
  const invalidSeatNumbers = [];

  const emptySeats = orders?.seats?.seats.filter(elem => {
    return (
      elem.open &&
      !availableInCart(elem, orders.cart) &&
      !availableInItem(elem, orders.seats.items)
    );
  });

  orders.seats?.items.forEach(sentItem => {
    const seatId = sentItem?.seats?.[0]?.seatId;
    const items = mapItemsWithSeatIds.get(seatId);
    if (items) {
      mapItemsWithSeatIds.set(seatId, [...items, sentItem]);
    } else {
      mapItemsWithSeatIds.set(seatId, [sentItem]);
    }
  });

  orders.cart.forEach(item => {
    const seatId = item?.seatIds?.[0];
    const items = mapItemsWithSeatIds.get(seatId);
    if (items) {
      mapItemsWithSeatIds.set(seatId, [...items, item]);
    } else {
      mapItemsWithSeatIds.set(seatId, [item]);
    }
  });

  mapItemsWithSeatIds.forEach((itemsArray, seatId) => {
    const seat = orders.seats.seats.filter(item => {
      return item.id === seatId;
    });
    if (seat[0]?.open) {
      if (!checkItemValidity(itemsArray)) {
        invalidSeatsId.push(seatId);
      }
    }
  });

  emptySeats.forEach(emptySeat => {
    invalidSeatNumbers.push(emptySeat.number);
  });
  invalidSeatsId.forEach(id => {
    invalidSeatNumbers.push(getSeatNumber(id));
  });
  const uniqueInvalidSeatNumbers = [...new Set(invalidSeatNumbers)];
  return uniqueInvalidSeatNumbers.sort((a, b) => a - b);
};

export const deleteAllItems = (checkedItems = null) => {
  const { orders } = store.getState();

  const inProcessItems = orders?.cart?.filter(e => {
    if(checkedItems) return checkedItems[e.internalId] && e.isProcessing;
    return e.isProcessing;
  });

  const itemsToDelete = orders?.cart?.filter(e => {
    if(checkedItems) return (checkedItems[e.internalId] || checkedItems[e.id]) && !e.isProcessing;
    return !e.isProcessing;
  });

  const check = orders?.seats;

  if (inProcessItems?.length > 0) {
    inProcessItems.forEach(item => {
      store.dispatch(removeItemFromCart(item.internalId));
    });
    const checkItems = getObjectValue(() => check?.orders[0]?.items, []).filter(
      e => !e.pending
    );
    const updatedCheckHeader = {
      ...check,
      orders: check?.orders?.map((order, index) => {
        if (index === 0) {
          return {
            ...order,
            items: checkItems,
          };
        }
        return order;
      }),
    };
    store.dispatch(
      updateChecksAfterResponse(updatedCheckHeader)
    );
  }
  const updatedCart = getUpdatedCart();
  CustomEventEmitter.dispatchEvent('getCartItems', updatedCart);
  if (itemsToDelete.length > 0) {
    deleteSelectedItems(itemsToDelete);
  }
};

const deleteSelectedItems = data => {
  const { orders, oauth } = store.getState();
  const userInfo = oauth.loggedInUserData;

  const datatosend = {
    storeId: oauth?.deviceInformation?.storeId,
    deviceId: oauth?.deviceInformation?.deviceId,
    employeeId: oauth?.loggedInUserData?.id,
    checkHeaderId: orders?.seats?.id,
    employeeCard: userInfo?.employeeCard,
    items: getLinkedMenuItemsId(data),
  };
  store.dispatch(setUpdatingPosCartStatus(true));
  store
    .dispatch(deleteItm(datatosend))
    .then(res => {
      store.dispatch(setUpdatingPosCartStatus(false));
      const ItemsArray = res.orders[0]?.items || [];
      const CartItems = [];
      ItemsArray.forEach(item => {
        if (item.pending && item.itemType !== 'D') {
          const cartData = {
            ...safeJsonParse(
              safeJsonParse(item?.orderJson, {})?.modifierJson,
              {}
            ),
            isProcessing: false,
            modifierJson: safeJsonParse(item?.orderJson, {})?.modifierJson,
            id: item.id,
            checkItemId: item.checkItemId,
            pending: item?.pending,
            // seatIds: item?.seats?.map(s => s.seatId) || [],
          };
          CartItems.push(cartData);
        }
      });
      replaceCart(CartItems);
      const updatedCart = getUpdatedCart();
      CustomEventEmitter.dispatchEvent('getCartItems', updatedCart);
      updateChecksAfterResponse(res);
      updateSeatInfo({ ...res });
    })
    .catch(err => {
      store.dispatch(setUpdatingPosCartStatus(false));
      store.dispatch(
        setErrorPopUp({
          res: err.message,
        })
      );
    });
};

export const handleVoidItems = ({ closeVoidCheck = () => { }, navigate = () => { }, isSingleItemClick = false }) => {
  const { orders, oauth } = store.getState();

  const userInfo = oauth?.loggedInUserData;
  const deviceInfo = oauth?.deviceInformation;
  const check = orders?.seats;
  const voidItemData = orders?.voidItemData;

  const dataToSend = {
    employeeId: Number(userInfo?.id),
    storeId: deviceInfo?.storeId,
    checkHeaderId: check?.id,
    // checkItemId: data.selectedItem[0].id
    items: voidItemData?.map(item => {
      return {
        checkItemId: item.id,
      };
    }),
  };
  store
    .dispatch(voidItm(dataToSend))
    .then(res => {
      store.dispatch(setSeat(res));
      store.dispatch(updateChecksAfterResponse(res));

      if(!isSingleItemClick){
        navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
          replace: true,
        });
      }
      // setIsSingleItemClick(false);
    })
    .catch(err => {
      store.dispatch(
        setErrorPopUp({
          res: err.message,
        })
      );
    })
    .finally(() => {
      closeVoidCheck();
    })
};

export const handleVoidCheck = ({ closeVoidCheck = () => { }, navigate = () => { } }) => {
  const { orders, oauth } = store.getState();
  const userInfo = oauth?.loggedInUserData;
  const deviceInfo = oauth?.deviceInformation;
  const check = orders?.seats;
  const deviceType = getDeviceType();

  const dataToSend = {
    employeeId: Number(userInfo?.id),
    storeId: deviceInfo?.storeId,
    checkHeaderId: check?.id,
    employeeCard: userInfo?.employeeCard,
    deviceId: deviceInfo?.deviceId
  };
  store
    .dispatch(voidCheck(dataToSend))
    .then(res => {
      store.dispatch(updateChecksAfterResponse(res));
      if (deviceType?.isCallCenter) {
        navigate(`${APP_CONFIG.BASE_URL}/callCenterError`, {
          replace: true,
        });
      } else {
        navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
          replace: true,
        });
      }
    })
    .catch(err => {
      store.dispatch(
        setErrorPopUp({
          res: err.message,
        })
      );
    })
    .finally(() => {
      closeVoidCheck();
    })
};

export const applyHoldItems = (items, { onSuccess, onError } = {}) => {
  const { orders, oauth } = store.getState();
  if (!items || !items.length) return;

  const holdTimeMap = {};
  items.forEach(item => {
    holdTimeMap[item.internalId] = item.holdTime;
  });

  const cb = (Cart, check) => {
    const itemsToUpdate = Cart
      .filter(cartItem => Object.prototype.hasOwnProperty.call(holdTimeMap, cartItem?.internalId))
      .map(cartItem => ({
        ...cartItem,
        holdTime: holdTimeMap[cartItem?.internalId],
        checkOrderItemId: cartItem?.id,
      }));

    if (itemsToUpdate.length === 0) {
      onSuccess?.();
      return;
    }

    const target = check || orders.seats;
    const dataToSend = {
      storeId: oauth?.deviceInformation?.storeId,
      deviceId: oauth?.deviceInformation?.deviceId,
      employeeId: Number(oauth?.loggedInUserData?.id),
      employeeCard: oauth?.loggedInUserData?.employeeCard,
      checkHeaderId: target?.id,
      stationId: target?.stationId,
      items: itemsToUpdate,
      orderJson: JSON.stringify(itemsToUpdate),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };

    store.dispatch(addChecks(dataToSend, 'update'))
      .then(res => {
        store.dispatch(updateSeatInfo(res));
        store.dispatch(updateChecksAfterResponse(res));
        const ItemsArray = res.orders?.[0]?.items || [];
        const CartItems = ItemsArray.reduce((acc, item) => {
          if (item.pending && item.itemType !== 'D') {
            acc.push({
              ...safeJsonParse(safeJsonParse(item?.orderJson || '{}')?.modifierJson || '{}'),
              isProcessing: false,
              modifierJson: safeJsonParse(item.orderJson || {})?.modifierJson,
              id: item.id,
              // seatIds: item?.seats?.map(s => s.seatId) || [],
            });
          }
          return acc;
        }, []);

        if (CartItems.length > 0) {
          store.dispatch(replaceCart(CartItems));
          CustomEventEmitter.dispatchEvent('getCartItems', CartItems);
        } else {
          store.dispatch(replaceCart([]));
          CustomEventEmitter.dispatchEvent('getCartItems', []);
        }

        onSuccess?.();
      })
      .catch(err => {
        store.dispatch(setErrorPopUp({ res: err.message }));
        onError?.();
      });
  };

  addInProcessItemsToCart(cb, orders.cart);
};
